// Таб, энтер, стрелочки
const NAVIGATION_BUTTONS_KEY_CODES = [9, 13, 37, 38, 39, 40];

export default NAVIGATION_BUTTONS_KEY_CODES;
